import { Component, OnInit } from '@angular/core';
import { Category } from '../../models/category';
import { Products } from '../../models/product';
import { Subject, take, takeUntil } from 'rxjs';
import { ProductsService } from '../../services/products.service';
import { CategoriesService } from '../../services/categories.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'products-list',
  templateUrl: './products-list.component.html',
  styles: [],
})
export class ProductsListComponent implements OnInit {
  products: Products[] = [];
  categories: Category[] = [];
  isCategoryPage!: boolean;
  endsubs$: Subject<any> = new Subject();

  constructor(
    private productsService: ProductsService,
    private categoryService: CategoriesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      params['categoryid']
        ? this._getProducts([params['categoryid']])
        : this._getProducts();
      params['categoryid']
        ? (this.isCategoryPage = true)
        : (this.isCategoryPage = false);
    });

    this._getCategories();
  }

  private _getProducts(categoriesFilter?: string[]) {
    this.productsService
      .getProducts(categoriesFilter)
      .pipe(takeUntil(this.endsubs$))
      .subscribe((products) => {
        this.products = products;
      });
  }

  private _getCategories() {
    this.categoryService
      .getCategories()
      .pipe(takeUntil(this.endsubs$))
      .subscribe((categories) => {
        this.categories = categories;
      });
  }

  categoryFilter() {
    const selectedCategories = this.categories
      .filter((category) => category.checked)
      .map((category) => category.id);

    this._getProducts(selectedCategories);
  }

  ngOnDestroy() {
    this.endsubs$.complete();
  }
}
